import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

/**
 * Returns per-month counts for group_tours and shared_rentals (next 12 months, public listings).
 * Shape: { "2026-02": { group_tours: 0, shared_rentals: 1 }, ... }
 */
export function getAvailabilityByMonth() {
  return axios({ method: 'get', url: `${API_URL}/availability_by_month` });
}
